import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { ECMID } from '../../../constants';
import { Link, useLocation } from 'react-router-dom';
import AddressModal from '../AddressModal';
import Breadcrumb from '../../../component/Breadcrumb';
import ClearIcon from '@mui/icons-material/Clear';
import LaunchIcon from '@mui/icons-material/Launch';
import { sheetOptionECUReceiveMessage } from '../../../constants';
import { fetchAutoCompleteDataForECUReceiveMessage } from '../../../api/mappingApi';
import { Grid, Typography, Box, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText, IconButton } from '@mui/material';
import FormNumberField from '../../../component/NumberInput';


const AddNewReceiveMessages = () => {
    const location = useLocation();
    const [open, setOpen]                               =   useState(false);
    const [sheetMappingData, setSheetMappingData]       =   useState([]);
    const [autoCompleteLoading, setAutoCompleteLoading] =   useState(false);
    const [searchValue, setSearchValue]                 =   useState('');
    const [sheetFilter, setSheetFilter]                 =   useState('');
    const [address, setAddress]                         =   useState('');
    const [fields,setFields]                            =   useState({
        Addr            : null,
        ECMID           : null,
        PGN             : null,
        StartByte       : null,
        StartBit        : null,
        Len             : null,
        Scaling         : null,
        Offset          : null,
        MxVldScaledVal  : null,
        DType           : null,
        Persistent      : null,
        SPN             : null,
        Desc            : null,
        CST             : null
    })

    useEffect(()=> {
        if(location.state?.rowId !== '' && location.state?.rowId !== undefined){
            let existingReceiveMessages = JSON.parse(localStorage.getItem('ECUReceiveMessages'));
            setFields(existingReceiveMessages[location.state?.rowId])
        }
    },[location.state?.rowId])

    // const changeHandler = (e) => {
    //     let value = e.target.name === 'PGN' ?  e.target.value.replace(/\D/g, "") : e.target.value;
    //     let name  = e.target.name;
    //     setFields((prevState) => ({...prevState, [name]: e.target.name !== 'PGN' ? value : isNaN(parseInt(value)) ? '' : parseInt(value)}))
    // }

    const changeHandler = (e) => {
        let value = e.target.name === 'PGN' ?  e.target.value.replace(/\D/g, "") : e.target.value;
        let name  = e.target.name;
        setFields((prevState) => ({...prevState, [name]: e.target.name !== 'PGN' ? value : isNaN(parseInt(value)) ? '' : parseInt(value)}))
    }

    const handleBlurUpdate = (name,value) => {
        let finalVal;
        if(name === 'MxVldScaledVal' || name === 'Scaling' || name === 'Offset'){
            const result = decimalValidation(name,value);
            if(result){
                swal("Oops!", "Please use Float value for Scaling, Offset and MxVldScaledVal!", "error");
            }
            if(value % 1 === 0){
                value = Number(value) === 0 ? 0.000001 : parseFloat(value) + 0.000001;
            }
            finalVal = value ? parseFloat(value) : '';
        } else {
            finalVal = parseInt(value);
        }
        setFields((prevState) => ({...prevState, [name]: finalVal}));
        //setFields((prevState) => ({...prevState, [name]: isNaN(parseFloat(value)) ? '' : parseFloat(value)}));
    } 

    const decimalValidation = (name,value) => {
        let validationArray = ['MxVldScaledVal','Scaling','Offset'];
        if(validationArray.includes(name) && value !== '' && value?.toString()?.indexOf('.') === -1) {
            return true;
        } 
        return false;
    }

    const handleSubmit = () => {
       // const isEmpty = !Object.values(fields).every(val => val !== null && val !== '');
        if(fields?.Addr === '' || fields?.Addr === null){
            swal("Oops!", "Address is required!", "error");
            return false;
        }
        const notEmpty = Object.values(fields).filter(val => val !== null && val !== '').length;
        if(notEmpty <= 1){
            swal("Oops!", "Please fill atleast one field!", "error");
            return false;
        }
        let valdationStatus = false;
        Object.keys(fields).forEach(function(key) {
            const result = decimalValidation(key,fields[key]);
            if(result){
                valdationStatus = true;
            }        
        });

        if(valdationStatus){
            swal("Oops!", "Please use Float value for Scaling, Offset and MxVldScaledVal!", "error");
            return false;
        }
        let existingReceiveMessages = JSON.parse(localStorage.getItem('ECUReceiveMessages'));
        if(existingReceiveMessages == null) existingReceiveMessages = [];
        let isExist = false;
        let removeNullKeyFields     = Object.fromEntries(Object.entries(fields).filter(([_, v]) => v != null));
        if(existingReceiveMessages  != null && existingReceiveMessages.length > 0){
            existingReceiveMessages =  existingReceiveMessages?.map((message) =>  {
            if(message.Addr === removeNullKeyFields.Addr){
              isExist = true;
              return {...message,...removeNullKeyFields}
            } else {
              return message;
            }
          });
        } 
        if(!isExist){
            existingReceiveMessages.push(removeNullKeyFields);
        }
        localStorage.setItem('ECUReceiveMessages',JSON.stringify(existingReceiveMessages));
        swal({
            title: "Success",
            text: 'ECU Receive Messages added successfully.',
            icon: "success",
        })
        setFields({
            Addr            :   null,
            ECMID           :   null,
            PGN             :   null,
            StartByte       :   null,
            StartBit        :   null,
            Len             :   null,
            Scaling         :   null,
            Offset          :   null,
            MxVldScaledVal  :   null,
            DType           :   null,
            Persistent      :   null,
            SPN             :   null,
            Desc            :   null,
            CST             :   null
        })
    }

    const handleClickOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        setSearchValue('');
        setSheetFilter('');
    };

    const handleSheetFilter = (e) => {
        setSheetFilter(e.target.value)
    }

    const handleSearchValueAutoComplete = (value) => {
        setSearchValue(value)
    }

    useEffect(() => {
        if(searchValue === ''){
            setSheetMappingData([]);
            return;
        }
        let active;
        if(sheetFilter){
            active = true;
            ( async () => {
                    setAutoCompleteLoading(true);
                    const data = await fetchAutoCompleteDataForECUReceiveMessage(searchValue);
                    if(active){
                        setSheetMappingData(data);
                        setAutoCompleteLoading(false);
                    }
                }
            )();
        }
        return () => {
            active = false;
        }
    },[sheetFilter,searchValue])

    const handleChangeAutoComplete = (value) => {
        const address = value?.Address ? value?.Address : '';
        setAddress(address);
    }

    const handleModalSubmit = () => {
        setOpen(false);
        setSearchValue('');
        setSheetFilter('');
        setFields((prevUpdate) => ({...prevUpdate, "Addr": address }));
    } 

    const handleClearAddress = () => {
        setFields((prevUpdate) => ({...prevUpdate, "Addr": null }));
    }

   
    return (
        <>
            <Breadcrumb title={location.state?.rowId !== '' &&  location.state?.rowId !== undefined ? 'Edit' : 'Add New' }>
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                    Dashboard
                </Typography>
                <Typography component={Link} to={location.pathname.includes('mapping') ? '/mapping/can/receive-messages' : '/can/receive-messages'} variant="subtitle2" color="primary" className="link-breadcrumb">
                ECUReceiveMessages
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                {location.state?.rowId !== '' &&  location.state?.rowId !== undefined ? 'Edit' : 'New' }
                </Typography>
            </Breadcrumb>
            <Box component="section">
                <Grid className="contentBox">

                    <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                        <Grid item>
                            <Button
                                component={Link} 
                                to={location.pathname.includes('mapping') ? '/mapping/can/receive-messages' : '/can/receive-messages'}
                                variant="contained"
                                size="small"
                                color="primary"
                                sx={{mr:3}}
                            >Back 
                            </Button>
                        </Grid>
                    </Grid>
                    
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={10} sm={3} md={3}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Addr"
                                label="Address"
                                name="Addr"
                                value={fields.Addr || ""}
                                error={fields.Addr === "" || fields.Addr === null}
                                helperText={fields.Addr === "" || fields.Addr === null ? "Required Field!" : false}
                                disabled={true}
                             />
                        </Grid>
                        <Grid item xs={1} sm={0.5} md={0.5} sx={{mt:2}}>
                            <IconButton 
                                disableRipple
                                size='small'
                                color='inherit'
                                //sx={{mt:2}}
                                onClick={handleClickOpen}
                            >
                                <LaunchIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={1} sm={0.5} md={0.5} sx={{mt:2}}>
                            <IconButton 
                                disableRipple
                                size='small'
                                color='inherit'
                               // sx={{mt:2}}
                                onClick={handleClearAddress}
                            >
                                <ClearIcon />
                            </IconButton>
                        </Grid>
                        
                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl
                                margin="dense"
                                fullWidth
                            >
                                <InputLabel id="demo-simple-select-standard-label">ECMID</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    sx={{
                                        "&:focus": {
                                            backgroundColor: "#ffffff"
                                        }
                                    }}
                                    label="ECMID"
                                    value={fields.ECMID ? fields.ECMID : fields.ECMID === 0 ? fields.ECMID : '' || ""}
                                    onChange={changeHandler}
                                    name="ECMID"
                                    //error={fields.ECMID === ""}
                                >
                                    <MenuItem value="">Select ECMID</MenuItem>
                                    {ECMID?.map((opt) => (
                                        <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
                                    ))}
                                </Select>
                                {/* <FormHelperText sx={{color:"#d32f2f"}} >{fields.ECMID === "" ? "Required Field!" : false}</FormHelperText> */}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="PGN"
                                label="PGN"
                                name="PGN"
                                value={fields.PGN || ""}
                                onChange={changeHandler}
                               // error={fields.PGN === ""}
                               // helperText={fields.PGN === "" ? "Required Field!" : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="StartByte"
                                label="StartByte"
                                name="StartByte"
                                value={fields.StartByte || ""}
                                onBlurUpdate={handleBlurUpdate}
                               // error={true}
                               // helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="StartBit"
                                label="StartBit"
                                name="StartBit"
                                value={fields.StartBit || ""}
                                onBlurUpdate={handleBlurUpdate}
                               // error={true}
                               // helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="Len"
                                label="Len"
                                name="Len"
                                value={fields.Len || ""}
                                onBlurUpdate={handleBlurUpdate}
                               // error={true}
                               // helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="Scaling"
                                label="Scaling"
                                name="Scaling"
                                value={fields.Scaling || ""}
                                onBlurUpdate={handleBlurUpdate}
                               // error={true}
                               // helperText={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="Offset"
                                label="Offset"
                                name="Offset"
                                value={fields.Offset || ""}
                                onBlurUpdate={handleBlurUpdate}
                               // error={true}
                               // helperText={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="MxVldScaledVal"
                                label="MxVldScaledVal"
                                name="MxVldScaledVal"
                                value={fields.MxVldScaledVal || ""}
                                onBlurUpdate={handleBlurUpdate}
                                //error={true}
                                //helperText={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                               // sx={{mt: { xs:'24px',sm:'8px',md:'8px'}}}
                                fullWidth
                                margin="dense"
                                id="DType"
                                label="DType"
                                name="DType"
                                value={fields.DType || ""}
                                onChange={changeHandler} 
                                //error={fields.DType === ""}
                                //helperText={fields.DType === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl
                                margin="dense"
                                fullWidth
                            >
                                <InputLabel id="demo-simple-select-standard-label">Persistent</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    sx={{
                                        "&:focus": {
                                            backgroundColor: "#ffffff"
                                        }
                                    }}
                                    label="Persistent"
                                    value={fields.Persistent ? fields.Persistent : fields.Persistent === 0 ? fields.Persistent : '' || ""}
                                    onChange={changeHandler}
                                    name="Persistent"
                                  //  error={fields.Persistent === ""}
                                >
                                    <MenuItem value="">Select Persistent</MenuItem>
                                    <MenuItem value={1}>Yes</MenuItem>
                                    <MenuItem value={0}>No</MenuItem>
                                </Select>
                                {/* <FormHelperText sx={{color:"#d32f2f"}} >{fields.Persistent === "" ? "Required Field!" : false}</FormHelperText> */}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="SPN"
                                label="SPN"
                                name="SPN"
                                value={fields.SPN || ""}
                                onBlurUpdate={handleBlurUpdate}
                                //error={true}
                                //helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField
                                //sx={{mt: { xs:'24px',sm:'8px',md:'8px'}}}
                                fullWidth
                                margin="dense"
                                id="Desc"
                                label="Desc"
                                name="Desc"
                                value={fields.Desc || ""}
                                //multiline
                                rows={4}
                                onChange={changeHandler}
                                //error={fields.Desc === ""}
                                //helperText={fields.Desc === "" ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="CustomText"
                                label="Custom Text"
                                name="CST"
                                value={fields?.CST || ""}
                                onChange={changeHandler}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <Grid container direction="row" spacing={1} display={'flex'} justifyContent={'flex-start'}>
                            <Grid item>
                                <Button
                                    onClick={handleSubmit}
                                    variant="contained"
                                    size="medium"
                                    color="primary"
                                    sx={{mt:2}}
                                >Submit
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    component={Link} 
                                    to={location.pathname.includes('mapping') ? '/mapping/can/receive-messages' : '/can/receive-messages'}
                                    variant="contained"
                                    size="medium"
                                    color="error"
                                    sx={{mt:2}}
                                >Cancel
                                </Button>
                            </Grid>
                        </Grid> 
                    </Grid> 
                    <AddressModal 
                        open={open}
                        options={sheetOptionECUReceiveMessage}
                        onClose={handleClose}
                        sheetFilter={sheetFilter}
                        handleSheetFilter={handleSheetFilter} 
                        handleModalSubmit={handleModalSubmit}
                        autoCompleteOptions={sheetMappingData}
                        autoCompleteLoading={autoCompleteLoading}
                        handleChangeAutoComplete={handleChangeAutoComplete}
                        handleSearchValueAutoComplete={handleSearchValueAutoComplete}
                    />
                </Grid>
            </Box>
        </>
    );
};

export default AddNewReceiveMessages;
